var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('span',{attrs:{"id":"RTE__command__bold"}},[_vm._v("B")])])}
var staticRenderFns = []

export { render, staticRenderFns }